<script>
import Product from '@phoenix/mixins/components/common/Product';
import WishlistButton from '@maison/components/wishlist/WishlistButton';
import { PhxsgProductCard } from '@sg/src/View/Components/Molecules/ProductCard';

export default {
  components: {
    PhxsgProductCard,
    WishlistButton,
  },

  mixins: [Product],

  props: {
    displayClasses: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    sliderImages: {
      type: Array,
      default: () => [],
    },
    enableSlider: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    containerClasses() {
      return ['product-card', ...this.displayClasses];
    },

    hasSliderImages() {
      return this.enableSlider && this.sliderImages && this.sliderImages.length > 1;
    },

    computedMedias() {
      if (this.hasSliderImages) {
        return this.sliderImages;
      }

      return this.image ? [this.image] : [];
    },

    dataTrackingJson() {
      return this.dataTracking ? JSON.stringify(this.dataTracking) : null;
    },
  },
};
</script>

<template>
  <phxsg-product-card
    :medias="computedMedias"
    :enable-slider="hasSliderImages"
    :name="name"
    :product-ref="modelReference"
    :tags="labels"
    :href="url"
    :class="containerClasses"
    :data-tracking="dataTrackingJson"
    :previous-slide-label="$t('Button.previousSlide')"
    :next-slide-label="$t('Button.nextSlide')"
    data-cy="product-card"
  >
    <template #price>
      <product-price v-bind="localizedPrice" :should-display-from-price="shouldDisplayFromPrice" />
    </template>

    <template v-if="shouldDisplayAddToWishlist" #actions>
      <wishlist-button :reference="modelReference" :tracking="tracking" />
    </template>
  </phxsg-product-card>
</template>
